import { useTranslation } from 'react-i18next';
import { typeCondition } from '../enum/typeCondition';
import { typeProfil } from '../enum/typeProfil';

export const useLabelValue = () => {
  const {t} = useTranslation();
  const setLabelProfile = profile => {
    switch (profile) {
      case typeProfil.TYPE_1: 
        return t('form.profile-walk');
      case typeProfil.TYPE_2: 
        return t('form.profile-visual');
      case typeProfil.TYPE_3: 
        return t('form.profile-wheelchair');
      case typeProfil.TYPE_4: 
        return t('form.profile-hearing');
      case typeProfil.TYPE_5: 
        return t('form.profile-mental');
      default: 
        return;
    }
  };
  const setLabelCondition = condition => {
    switch(condition) {
      case typeCondition.TYPE_WALK_EASY:
        return t('form.condition-walk-easy'); 
      case typeCondition.TYPE_WALK_NORMAL:
        return t('form.condition-walk-normal'); 
      case typeCondition.TYPE_WALK_DIFF:
        return t('form.condition-walk-difficult');
      case typeCondition.TYPE_VISUAL_PART:
        return t('form.condition-visual-partial');
      case typeCondition.TYPE_VISUAL_TOT:
        return t('form.condition-visual-totale');
      case typeCondition.TYPE_WHEEL_MAN:
        return t('form.condition-wheelchair-manual');
      case typeCondition.TYPE_WHEEL_ELE:
        return t('form.condition-wheelchair-electric');
      case typeCondition.TYPE_HEAR_PART:
        return t('form.condition-hearing-partial');
      case typeCondition.TYPE_HEAR_TOT:
        return t('form.condition-hearing-total');
      case typeCondition.TYPE_MEN_INT:
        return t('form.condition-mental-intel');
      case typeCondition.TYPE_MEN_PSY:
        return t('form.condition-mental-psy');
      default:
        return;     
    }
  };

  const displayType = (type) => ({
    'path': t('stepPath.label-type-path'),
    'sidewalk': t('stepPath.label-type-sidewalk'),
    'crosswalk': t('stepPath.label-type-crosswalk'),
    'steps': t('stepPath.label-type-steps'),
    'foot': t('stepPath.label-type-steps'),
    'bus': t('stepPath.label-type-bus'),
    'tramway': t('stepPath.label-type-tramway'),
    'wheelchair': t('stepPath.label-type-wheelchair')
  }[type] || t('stepPath.label-unknown')); 

  const displaySurfaceType = (type) => ({
    'asphalt': t('stepPath.surface_asphalt'),
    'paved': t('stepPath.surface_pave'),
    'concrete': t('stepPath.surface_concrete'),
    'wood': t('stepPath.surface_wood'),
    'earth': t('stepPath.surface_earth'),
    'gravel': t('stepPath.surface_gravel'),
    'grass': t('stepPath.surface_grass'),
    'tiles': t('stepPath.surface_tiles'),
    'plastic': t('stepPath.surface_plastic'),
    'metal': t('stepPath.surface_metal'),
    'compacted': t('stepPath.surface_compacted'),
    'carpet': t('stepPath.surface_carpet'),
    'rubber': t('stepPath.surface_rubber'),
    'cork': t('stepPath.surface_cork'),
    'fibre_glass_grating': t('stepPath.surface_glass_grating'),
    'glazed_ceramic_tiles': t('stepPath.surface_glazed_ceramic_tiles'),
    'vinyl': t('stepPath.surface_vinyl'),
    'uneven': t('stepPath.surface_uneven')
  }[type] || t('stepPath.label-unknown')); 

  const displaySmoothnessLevel = (type) => ({
    'good': t('stepPath.surface_state_good'),
    'intermediate': t('stepPath.surface_state_intermediate'),
    'bad': t('stepPath.surface_state_bad'),
    'very_bad': t('stepPath.surface_state_very_bad')
  }[type] || t('stepPath.label-unknown'));

  const displayKerbDesign = (type) => ({
    'lowered': t('stepPath.kerbdesign_lowered'),
    'raised': t('stepPath.kerbdesign_raised')
  }[type] || t('stepPath.label-unknown'));

  const displayPedestrianLights = (type) => ({
    'no': t('stepPath.noPedestrianlights'),
    'yes': t('stepPath.withPedestrianlights')
  }[type] || t('stepPath.label-unknown'));

  const displayZebracrossing = (type) => ({
    'good': t('stepPath.goodLabel'),
    'intermediate': t('stepPath.intermediateLabel'),
    'bad': t('stepPath.badLabel'),
    'no': t('stepPath.noPedestrianlights'),
    'yes': t('stepPath.withPedestrianlights')
  }[type] || t('stepPath.label-unknown'));

  const displayTactileWarningStrip = (type) => ({
    'very_good': t('stepPath.veryGoodLabel'),
    'good': t('stepPath.goodLabel'),
    'bad': t('stepPath.badLabel'),
    'very_bad': t('stepPath.veryBadLabel'),
    'intermediate': t('stepPath.intermediateLabel'),
    'no': t('stepPath.noPedestrianlights'),
    'yes': t('stepPath.withPedestrianlights')
  }[type] || t('stepPath.label-unknown'));

  return {
    setLabelProfile, 
    setLabelCondition, 
    displayType,
    displaySurfaceType,
    displaySmoothnessLevel,
    displayKerbDesign,
    displayPedestrianLights,
    displayZebracrossing,
    displayTactileWarningStrip
  };
};